import { Type } from "src/utils";

/**
 * 表示一个服务平台订单状态枚举。
 * @enum
 * @version 1.0.0
 */
enum ServerOrderStatus
{
    /**
     * 待付款
     * @member
     */
     ToPay  = 1,

    /**
     * 认购成功
     * @member
     */
     Payed = 2,

    /**
     * 审核中 
     * @member
     */
     Auditing  = 3,

    /**
     * 认购失败
     * @member
     */
     Failed = 4,

     /**
      * 订单取消
      * @member
      */
      Cancel = 5
}

/*
* 定义枚举元数据。
*/
Type.setMetadata(ServerOrderStatus,
{
    ToPay:
    {
        alias: "待付款",
        description: ""
    },
    Payed:
    {
        alias: "认购成功",
        description: ""
    },
    Auditing:
    {
        alias: "审核中",
        description: ""
    },
    Failed:
    {
        alias: "认购失败",
        description: ""
    },
    Cancel:
    {
        alias: "订单取消",
        description: ""
    }
});

export default ServerOrderStatus;